<template>
  <b-modal
    id="modal-send-attachment"
    ok-variant="primary"
    :ok-title="$t('Send')"
    :cancel-title="$t('Cancel')"
    centered
    hide-header
    no-close-on-backdrop
    @shown="showPreview"
    @ok="replyTicket"
  >
    <div
      v-if="loader"
      class="d-flex justify-content-center"
    >
      <b-spinner variant="primary" />
    </div>
    <div
      v-show="!loader"
      class="file-preview"
    >
      <div v-if="type === 'image'">
        <b-img
          ref="source"
          src=""
          thumbnail
        />
      </div>
      <div v-else-if="type === 'video'">
        <video>
          <source
            ref="source"
            src=""
            type="video/mp4"
          >
        </video>
      </div>
      <div
        v-else
        class="d-flex align-items-center flex-wrap"
      >
        <!--begin::Symbol-->
        <div class="symbol symbol-50 symbol-light mr-5">
          <span class="symbol-label">
            <span class="svg-icon svg-icon-secondary">
              <inline-svg src="/media/svg/icons/Files/File.svg" />
            </span>
          </span>
        </div>
        <!--end::Symbol-->
        <!--begin::Text-->
        <div class="d-flex flex-column flex-grow-1 mr-2">
          <a
            href="#"
            class="
              font-weight-bold
              text-dark-75 text-hover-primary
              font-size-lg
              mb-1
            "
          >{{ file.name }}</a>
          <span class="text-muted font-weight-bold">{{
            file.size | humanFileSize
          }}</span>
        </div>
        <!--end::Text-->
      </div>
    </div>
    <b-form-textarea
      v-model="form.content"
      class="form-control-solid h-auto py-6 line-height-md mt-4"
      :placeholder="$t('Content')"
      name="content"
      no-resize
    />
  </b-modal>
</template>

<script>
import {
  BModal, BFormTextarea, BImg, BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'TicketsReplayAttachmentModal',
  components: {
    BModal,
    BFormTextarea,
    BImg,
    BSpinner,
  },
  props: {
    file: {
      type: [File, Array],
      default: () => [],
    },
  },
  data() {
    return {
      loader: false,
      type: 'image',
      form: {
        content: '',
      },
    }
  },
  methods: {
    showPreview() {
      this.form.content = ''
      // eslint-disable-next-line prefer-destructuring
      this.type = this.file.type.split('/')[0]
      if (this.type === 'image') {
        const fr = new FileReader()
        fr.onloadstart = () => {
          this.loader = true
        }
        fr.onload = () => {
          this.$refs.source.src = fr.result
        }
        fr.onloadend = () => {
          this.loader = false
        }
        fr.readAsDataURL(this.file)
      } else if (this.type === 'video') {
        this.$refs.source.src = window.URL.createObjectURL(this.file)
      }
    },
    replyTicket() {
      return this.$emit('onReplyTicket', this.form.content)
    },
  },
}
</script>

<style scoped></style>
